import { createFileRoute } from "@tanstack/react-router";
import { externalRedirect } from "@/lib/routeRedirect";

export const Route = createFileRoute("/jobs.xml")({
  beforeLoad: externalRedirect(`https://${import.meta.env.VITE_SUPABASE_PROJECT_ID}.supabase.co/functions/v1/jobs-feed`),
});
